import { useState, useEffect } from "react";
import { ListFilter } from "./listTableType";
import { FONT } from "../../../value/staticValues";
import { 
    StyleSheet, View, Text
} from "react-native";


interface CategoryFilterItemProps {
    id: number,
    name: string,
    type: string,
    code: string,
    count: number,
    activeId: number,
    clickCb: Function,
}

function CategoryFilterItem(props:CategoryFilterItemProps) {
    const [categoryFilterItemNameStyle, setCategoryFilterItemNameStyle] = useState(className.categoryFilterItemName);
    const [categoryFilterItemUnderlineStyle, setCategoryFilterItemUnderlineStyle] = useState(className.categoryFilterItemUnderline);

    useEffect(() => {
        if(props.activeId === props.id) {
            setCategoryFilterItemUnderlineStyle({...className.categoryFilterItemUnderline, border: "solid 2px #3c5df2"});
            setCategoryFilterItemNameStyle({...className.categoryFilterItemName, color: "#4f5fd8"});
        } else {
            setCategoryFilterItemUnderlineStyle({...className.categoryFilterItemUnderline, border: "solid 0px #fff"});
            setCategoryFilterItemNameStyle({...className.categoryFilterItemName, color: "#252525"});
        }
    }, [props]);

    function clickItem(id:number, type:string, code:string) {
        props.clickCb(id, type, code);
    }

    return (
        <View>
            <div style={className.categoryFilterItemContainer} onClick={(e) => clickItem(props.id, props.type, props.code)}>
                <div style={categoryFilterItemNameStyle}>{props.name}</div>
                <Text style={style.categoryFilterItemCount}>{props.count}</Text>
            </div>
            <div style={categoryFilterItemUnderlineStyle}></div>
        </View>
    );
                
}



interface CategoryFilterProps {
    filters: ListFilter[],
    clickCb: Function
}

function CategoryFilter(props:CategoryFilterProps) {
    const [filters, setFilters] = useState(props.filters);
    const [activeId, setActiveId] = useState(1);
    
    useEffect(() =>{
        setFilters(props.filters);
    }, [props])

    function clickCategoryFilterItem(id:number, type:string, code:string) {
        setActiveId(id);
        props.clickCb(type, code);
    }
    return (
        <View style={style.categoryFilterContainer}>
            {
                filters.map((filter:ListFilter, index) => {
                    return <CategoryFilterItem
                            key={index}
                            id={filter.id} 
                            type={filter.type}
                            name={filter.name}
                            code={filter.code}
                            count={filter.count || 0}
                            clickCb={clickCategoryFilterItem}
                            activeId={activeId}
                            />
                })
                
            }
        </View>
    )
}



const style = StyleSheet.create({
    topContainer: {

    },
    categoryFilterContainer: {
        flexDirection: "row",
        marginBottom: 21,
        borderBottomWidth: 1,
        borderBottomColor: "#e4e7eb",
    },
    categoryFilterItemCount: {
        marginLeft: 5,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 1.09,
        color: "#797d80"
    },

});

const className = {
    categoryFilterItemContainer: {
        height: "33px",
        padding: "5px 14px 8px 14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",

    },
    categoryFilterItemName: {
        fontFamily: FONT.REGULAR,
        fontSize: "12px",
        lineHeight: "1",
        color: "#252525"
    },
    categoryFilterItemUnderline: {
        marginBottom: "-2px",
        width: "inherit",
        height: "0px",
        borderRadius: "4px",
        border: "solid 0px #000",
    },

};

export default CategoryFilter;
